import { render, staticRenderFns } from "./LiteratureSectionNewElement.vue?vue&type=template&id=586fd044&"
import script from "./LiteratureSectionNewElement.vue?vue&type=script&lang=js&"
export * from "./LiteratureSectionNewElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports